module.exports = __webpack_public_path__ + "img/galeria-forrageiras-2.7df3053c.jpg";